export const REDIRECT_AFTER_LOGIN = '/qa';
